// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__ix7U1","filesListContainer":"PosDisputesFiles_filesListContainer__1BggU","filesButton":"PosDisputesFiles_filesButton__14rsm"};